import * as Phaser from "phaser";
import { BasicScene } from "$/game/prefabs/scenes/BasicScene.ts";

export class ProgressBar extends Phaser.GameObjects.Container {
  private progressBar: Phaser.GameObjects.Graphics;
  private progressBox: Phaser.GameObjects.Graphics;
  private progressWidth: number;
  private progressHeight: number;

  constructor(
    private myScene: BasicScene,
    x: number,
    y: number,
    progressWidth: number,
    progressHeight: number,
  ) {
    super(myScene, x, y);

    this.progressWidth = progressWidth;
    this.progressHeight = progressHeight;

    this.progressBox = myScene.add.graphics();
    this.progressBar = myScene.add.graphics();

    this.add(this.progressBox);
    this.add(this.progressBar);

    this.progressBox.fillStyle(
      myScene.global.TUNER_TWA_CONFIG.palette.border,
      1,
    );
    this.progressBox.fillRoundedRect(0, 0, progressWidth, progressHeight, 10);

    this.progressBar.fillStyle(
      myScene.global.TUNER_TWA_CONFIG.palette.primary,
      1,
    );
    this.progressBar.fillRoundedRect(10, 10, 0, progressHeight - 20, 4);
  }

  updateProgress(value: number) {
    this.progressBar.clear();

    this.progressBar.fillStyle(
      this.myScene.global.TUNER_TWA_CONFIG.palette.primary,
      1,
    );
    this.progressBar.fillRoundedRect(
      10,
      10,
      (this.progressWidth - 20) * value,
      this.progressHeight - 20,
      4,
    );
  }
}
